let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dcWuM")).then(() => parcelRequire('3Vx3n'));